import { useQuery } from "@tanstack/react-query";
import { ToastService } from "@shared/lib/services";

import { GetInfluencers } from "@shared/lib/types/influencer";
import { BackednResponse } from "@shared/lib/types";
import { INFLUENCER_LIST_QUERY_KEY } from "../constants";
import { InfluencerService } from "../services/influencer.service";

export function useGetInfluencers(
  searchQuery?: string,
  platform?: string[],
  location?: string[],
  rating?: number,
  category?: string[],
  type?: string[],
  limit?: number,
  pageNo?: number,
  linkedAgencies?: string[]
) {
  const { data, isLoading, isError, error } = useQuery<
    BackednResponse<GetInfluencers>
  >({
    queryKey: [
      ...INFLUENCER_LIST_QUERY_KEY,
      searchQuery,
      platform,
      location,
      rating,
      category,
      type,
      limit,
      pageNo,
      linkedAgencies,
    ],
    queryFn: () =>
      InfluencerService.getInfluencers(
        searchQuery,
        platform,
        location,
        rating,
        category,
        type,
        limit,
        pageNo,
        linkedAgencies
      ),
  });

  const errorMessage = isError && error?.message;

  if (errorMessage) {
    ToastService.error(errorMessage);
  }

  return {
    influencers: data?.data,
    isFetching: isLoading,
    isError,
  };
}
